module.exports = __webpack_public_path__ + "static/media/ios_and.db2da1c2.svg";